import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { SearchDetailsService } from './search-details.service';
import { SearchResultObjectService } from 'src/app/shared/services/search-result-object.service';
import { SearchObjectService } from 'src/app/shared/services/search-object.service';
import { LoadingScreenService } from 'src/app/shared/components/loading-screen/loading-screen.service';
import { MatDialog } from '@angular/material/dialog';
import { SelectPcpComponent } from 'src/app/shared/components/select-pcp/select-pcp.component';
import { UserRulesService } from 'src/app/shared/services/user-rules.service';
//import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { SelectLocationComponent } from 'src/app/shared/components/select-location/select-location.component';
import { PcpsData } from 'src/app/shared/interfaces/search-result-object.interface';
import { PcpsService } from './../../shared/services/pcps.service';
import { SheetsService } from 'src/app/shared/components/sheets/sheets.service';
import { BrowseTypes, QueryTerms } from 'src/app/shared/models/QueryTerms';
import { FilterTerms } from 'src/app/shared/models/FIlterTerms';
import { MapService } from 'src/app/shared/services/map.service';

export const providers = ['Internal Medicine', 'Family Practice', 'General Practice', 'Pediatrics', 'Primary Care Provider (PCP)'];
@Component({
  selector: 'app-search-details',
  templateUrl: './search-details.component.html',
  styleUrls: ['./search-details.component.scss']
})
export class SearchDetailsComponent implements OnInit, OnDestroy {
  navigationSubscription;
  isValidSearch = false;

  //showDetails = false;
  detailData;
  otherDoctorData;
  setMap = false;
  params = {
    type: null,
    id: null,
    networkid: null,
    address: null,
    subproductkey: null,
    loginType: null,
    location: null,
    searchYear: null
  };

  hasUserLocation = false;
  dataNoMap = false;

  // level objects
  showLevels = false;
  showLevel1 = true;
  showDetailData = 5;
  showDetailDataDefault = 5;
  level1Length = 0;
  level2Length = 0;
  oDoctorL1Length = 0;
  oDoctorL2Length = 0;
  level1Location = [];
  level2Location = [];
  showLocationData = [];
  showLeveledNetworks = true;

  showServices = 5;
  showServicesDefault = 5;
  showOtherDoctors = 4;
  showOtherDoctorsDefault = 4;
  showOtherDoctorsInc = 4;
  showPlans = 5;
  showLanguages = 5;
  activeMarkerLetter = '';
  isPCP = false;
  isPCPSuccess = false;
  isPCPNetworkIdSubType = false;
  showDigital = false;
  selectedPcpOfficeId = '';
  pcpsData: PcpsData;
  selectedLocation = null;
  searchPcpValue: boolean;
  enablePcpBtn: boolean;
  enablePractitionersrPcpBtn: boolean;
  isAllowPcpChange: boolean;

  showNetworkSection = true;
  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private searchDetailsService: SearchDetailsService,
    private searchObjectService: SearchObjectService,
    private searchResultObjectService: SearchResultObjectService,
    private mapService: MapService,
    private loadingScreenService: LoadingScreenService,
    private __zone: NgZone,
    public _dialog: MatDialog,
    private _userRulesService: UserRulesService,
    //private GAService: GoogleAnalyticsService,
    private pcpsService: PcpsService,
    private sheetsService: SheetsService) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.initializeSearch();
      }
    });
  }

  ngOnInit() {
    this.searchPcpValue = providers.indexOf(this.searchObjectService.searchObject.userInput) !== -1;
    if (this.searchObjectService.isValidSearchObject()) {
      this.isValidSearch = true;
    }
    this.isPCPSuccess = false;
    this.isPCP = this._userRulesService.getIdToken() ? true : false;
    this.isPCPNetworkIdSubType = this.searchObjectService.checkNetworkSubKey(this.params.networkid, this.params.subproductkey);
    this.pcpsData = this.searchObjectService.getPcpData();
    this.isAllowPcpChange = (this.searchResultObjectService && this.searchObjectService.getMemberData() &&
       this.searchObjectService.getMemberData().allowPcpChange);
    this.showDigital = this.searchObjectService.getDigitalMember();
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  openMyPCPDialog(): void {
    const dialogRef = this._dialog.open(SelectPcpComponent, {
      width: (window.innerWidth > 865 ? 865 : window.innerWidth - 10) + 'px',
      data: this.detailData
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.isPCPSuccess = true;
        this.selectedPcpOfficeId = this.pcpsService.currentSelectedPcpId;
      }
    });
  }

  openSelectLocationDialog() {
    const dialogRef = this._dialog.open(SelectLocationComponent, {
      width: (window.innerWidth > 865 ? 865 : window.innerWidth - 10) + 'px',
      data: {
        detailData: this.detailData,
        otherDoctorData: this.otherDoctorData
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isPCPSuccess = true;
        this.selectedLocation = result;
      }
    });
  }

  isAcceptsMedicaidPlans() {
    return ((['0000010000010001100007','0000010000010001200005','0000010000010001400006','0000010000010001600005','0000010000010001700005','0000010000010002300007'].includes(this.params?.networkid)));
  }

  showMoreServices() {
    this.showServices = this.detailData.services.length;
  }

  showMoreDoctors() {
    this.showOtherDoctors += this.showOtherDoctorsInc;
  }

  showMorePlans() {
    this.showPlans = this.detailData.locations[0].plansAccepted.length;
  }

  showMoreLanguages() {
    this.showLanguages = this.detailData.locations[0].officeLanguages.length;
  }

  showMoreDetailData() {
    this.showDetailData += this.showDetailDataDefault;
  }

  // toggleDetails() {
  //   this.showDetails = !this.showDetails;
  // }

  initializeSearch() {
    this.loadingScreenService.toggleLoaderOn();
    //this.showDetails = false;
    this.detailData = null;
    this.otherDoctorData = null;
    this.activeMarkerLetter = '';

    this.params = {
      type: null,
      id: null,
      networkid: null,
      address: null,
      subproductkey: null,
      loginType: null,
      location: null,
      searchYear: null
    };

    this.showLevels = false;
    this.showLevel1 = true;
    this.showDetailData = 5;
    this.level1Length = 0;
    this.level2Length = 0;
    this.oDoctorL1Length = 0;
    this.oDoctorL2Length = 0;
    this.level1Location = [];
    this.level2Location = [];
    this.showLocationData = [];
    this.showLeveledNetworks = true;
    this.dataNoMap = false;
    //this.showDetails = false;
    this.hasUserLocation = false;
    this.showServices = this.showServicesDefault;
    this.showOtherDoctors = this.showOtherDoctorsDefault;

    this.searchDetails();
  }

  scrollView(): void {
    setTimeout(() => {
      if (document.querySelector('#scrollToTop')) {
          document.querySelector('#scrollToTop').scrollIntoView({behavior: 'smooth', block: 'start' });
      }
    }, 500);
  }
  searchDetails() {
    this.params[QueryTerms.type] = this.activatedRoute.snapshot.paramMap.get(QueryTerms.type);
    this.params[QueryTerms.id] = this.activatedRoute.snapshot.paramMap.get(QueryTerms.id);
    this.params[QueryTerms.networkid] = this.activatedRoute.snapshot.paramMap.get(QueryTerms.networkid);
    this.params[QueryTerms.location] = this.activatedRoute.snapshot.paramMap.get(QueryTerms.location);
    this.params[QueryTerms.address] = this.activatedRoute.snapshot.queryParamMap.get(QueryTerms.address);
    this.params[QueryTerms.subproductkey] = this.activatedRoute.snapshot.queryParamMap.get(QueryTerms.subproductkey);
    this.params[QueryTerms.loginType] = this.activatedRoute.snapshot.queryParamMap.get(QueryTerms.loginType);
    this.params[QueryTerms.searchYear] = this.activatedRoute.snapshot.queryParamMap.get(QueryTerms.searchYear);

    if ([BrowseTypes.find, BrowseTypes.shop, BrowseTypes.employer].includes(this.params[QueryTerms.loginType])) {
      this.showLeveledNetworks = false;
    }

    if (this.params[QueryTerms.address]) {
      this.hasUserLocation = true;
    }

    if (!this.params[QueryTerms.address]) {
      this.getServices(this.params[QueryTerms.type], this.params[QueryTerms.id], this.params[QueryTerms.networkid], this.params[QueryTerms.subproductkey], this.params[QueryTerms.searchYear]);
    } else if (this.searchObjectService.containsLatLong(this.params[QueryTerms.address])) {
      this.getServices(this.params[QueryTerms.type], this.params[QueryTerms.id], this.params[QueryTerms.networkid], this.params[QueryTerms.subproductkey], this.params[QueryTerms.searchYear]);
    } else {
      // if address different or latlong doesn't exist geocode the valid address
      let address = this.params[QueryTerms.address] ? this.params[QueryTerms.address] : this.searchObjectService.getAddress();
      this.mapService.searchFuzzy(address).then((res: any) => {
        this.__zone.run(() => {
          const addrs = res.geojson.getFeatures() as GeoJSON.FeatureCollection<GeoJSON.Point>;
          const feats = addrs.features;
          if (feats && feats.length > 0 && feats[0].properties && feats[0].properties!['address']) {
            this.getFormattedAddress(feats[0]);
          }
        });
      });
    }
  }

  getFormattedAddress(place: any, address?: string) {
    let county;
    const sendAddress = address ? address : place.properties?.address?.freeformAddress;
    if(sendAddress && !place.properties?.address?.countrySecondarySubdivision) {
      this.mapService.getAddressDetails(sendAddress).subscribe((resp: any) => {
        county = resp.features[0].properties.address.adminDistricts[1].shortName.replace(' Co.','');
        this.setLatLong(place, county);
      });
    } else {
      county = place.properties?.address?.countrySecondarySubdivision;
      this.setLatLong(place, county);
    }
  }

  setLatLong(place: any, county: string) {
    const address: any = this.mapService.getLocationObject(place, county);
    if (address && address.geometry && address.geometry.lat && address.geometry.lng) {
      this.searchObjectService.setLatLong(address.geometry.lat, address.geometry.lng);
    }
    this.getServices(this.params[QueryTerms.type], this.params[QueryTerms.id], this.params[QueryTerms.networkid], this.params[QueryTerms.subproductkey], this.params[QueryTerms.searchYear]);
  }

  clickLocation(location) {
    this.router.navigate(['/searchdetails', FilterTerms.Practitioner, this.params[QueryTerms.id], this.params[QueryTerms.networkid], location.officeId], {
      queryParams: {
        address: this.params[QueryTerms.address], subproductkey: this.params[QueryTerms.subproductkey], loginType: this.params[QueryTerms.loginType], searchYear: this.params[QueryTerms.searchYear]
      }
    });
  }

  setLocation(location, showPromoted) {
    if (location) {
      this.showLevels = false;
      this.detailData = this.searchResultObjectService.setLocationtoFacilityDetail(location);
      this.detailData.upmcOwnedDisplayIndicator = showPromoted;
      this.showLocationData = this.detailData.locations;
      this.showDetailData = this.showLocationData.length;
      this.showNetworkSection = true;
      if (this.showLocationData[0].plansAccepted.length === 1) {
        if (this.showLocationData[0].plansAccepted[0].subProductKey === this.params[QueryTerms.subproductkey]) {
          this.showNetworkSection = false;
        }
      }
      this.getLocationPractitioners(this.params[QueryTerms.id], this.params[QueryTerms.networkid], location.officeId, this.params[QueryTerms.subproductkey], this.params[QueryTerms.searchYear]);
      this.params[QueryTerms.type] = FilterTerms.Facility;
      this.scrollView();

      //this.GAService.pushDetailFacilityClick(this.detailData);
      //this.GAService.pushDetailFacilityLoad(this.detailData);
    }
  }
  checkpcpBtnEnabled(locations) {
    for (const location of locations) {
      if (location.isPcp) {
        this.enablePcpBtn = true;
      }
    }
  }
  showLevelToggle(event) {
    if (event) {
      this.showLocationData = this.level1Location;
    } else {
      this.showLocationData = this.level2Location;
    }
    this.activeMarkerLetter = '';
    this.showDetailData = this.showDetailDataDefault;
    this.showLevel1 = event;
  }

  private _setLetterToAddress() {
    const officeIds = {};
    const _letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '100', '101', '102', '103', '104', '105', '106', '107', '108', '109', '110', '111', '112', '113', '114', '115', '116', '117', '118', '119', '120', '121', '122', '123', '124', '125', '126', '127', '128', '129', '130', '131', '132', '133', '134', '135', '136', '137', '138', '139', '140', '141', '142', '143', '144', '145', '146', '147', '148', '149', '150', '151', '152', '153', '154', '155', '156', '157', '158', '159', '160', '161', '162', '163', '164', '165', '166', '167', '168', '169', '170', '171', '172', '173', '174', '175', '176', '177', '178', '179', '180', '181', '182', '183', '184', '185', '186', '187', '188', '189', '190', '191', '192', '193', '194', '195', '196', '197', '198', '199', '200' ];

    let index = 0;
    if (this.detailData) {
      for (const locations of this.detailData.locations) {
        if (locations) {
          if (!officeIds[locations['officeId']]) {
            if (index >= _letters.length) {
              index = 0;
            }
            officeIds[locations['officeId']] = _letters[index];
            index++;
          }
          locations.address['letter'] = officeIds[locations['officeId']];
        }
      }
    }
  }

  getServices(type, id, networkid, subproductkey, searchYear) {
    // if type provider or facility
    if (type === FilterTerms.Practitioner) {
      this.getProviderDetails(id, networkid, subproductkey, searchYear);
    } else if (type === FilterTerms.Facility) {
      this.getFacilityDetails(id, networkid, subproductkey, searchYear);
    }

  }

  getProviderDetails(id, networkid, subproductkey, searchYear) {
    this.searchDetailsService.getProviderDetails(id, networkid, subproductkey, searchYear).subscribe(data => {
      let location = [];
      this.detailData = this.searchResultObjectService.setPractitionerDetailtoResult(data);
      location = this.detailData.locations.filter(obj => obj.officeId === this.params.location);
      this.checkpcpBtnEnabled(this.detailData.locations);
      if (this.params.location && location.length > 0) {

        this._setLetterToAddress();
        this.setLocation(location[0], this.detailData.upmcOwnedDisplayIndicator);

      } else {

        this.showLocationData = this.detailData.locations;
        this.level1Location = this.detailData.locations.filter(obj => obj.level === '1');
        this.level2Location = this.detailData.locations.filter(obj => obj.level === '2');
        this.level1Length = this.level1Location.length;
        this.level2Length = this.level2Location.length;

        if (this.level1Length > 0 || this.level2Length > 0) {
          this.showLevels = true;
          this.showLocationData = this.level1Location;

          if (this.level1Length === 0) {
            this.showLevel1 = false;
            this.showLocationData = this.level2Location;
          }
        }
        this._setLetterToAddress();

        //this.GAService.pushDoctorDetailLoad(this.detailData);
      }
    }, error => {
      this.loadingScreenService.toggleLoaderOff();
    }, () => {
      this.loadingScreenService.toggleLoaderOff();
      this.scrollView();
    });
  }

  getFacilityDetails(id, networkid, subproductkey, searchYear) {
    this.searchDetailsService.getProviderDetails(id, networkid, subproductkey, searchYear).subscribe(data => {
      this.detailData = this.searchResultObjectService.setFacilityDetailtoResult(data);
      this.showLocationData = this.detailData.locations;
      this.showNetworkSection = true;
      if (this.showLocationData.length > 0) {
        if (this.showLocationData[0].plansAccepted.length === 1) {
          if (this.showLocationData[0].plansAccepted[0].subProductKey === this.params.subproductkey) {
            this.showNetworkSection = false;
          }
        }
      }
      this._setLetterToAddress();

      //this.GAService.pushDetailFacilityLoad(this.detailData);
    }, error => {
      this.loadingScreenService.toggleLoaderOff();
    }, () => {
      this.loadingScreenService.toggleLoaderOff();
      this.scrollView();
    });
  }

  getLocationPractitioners(id, networkid, officeid, subproductkey, searchYear) {
    this.searchDetailsService.getLocationPractitioners(id, networkid, officeid, subproductkey, searchYear).subscribe(data => {
      this.otherDoctorData = data;
      this.checkPcpPractitionersrBtn(this.otherDoctorData);
      this.oDoctorL1Length = this.otherDoctorData.practitioners.filter(obj => obj.level === '1').length;
      this.oDoctorL2Length = this.otherDoctorData.practitioners.filter(obj => obj.level === '2').length;
      if (this.oDoctorL1Length > 0 || this.oDoctorL2Length > 0) {
        this.showLevels = true;
        if (this.oDoctorL1Length === 0) {
          this.showLevel1 = false;
        }
      }

      //this.GAService.pushRelatedProviderLoad(this.otherDoctorData);
    }, error => {
      this.loadingScreenService.toggleLoaderOff();
    }, () => {
      this.loadingScreenService.toggleLoaderOff();
    });
  }
  checkPcpPractitionersrBtn(practitioner) {
    for (const location of practitioner.practitioners) {
      if (location.isPcp) {
        this.enablePractitionersrPcpBtn = true;
      }
    }
  }
  createEmpty(number) {
    const items = [];
    for (let i = 0; i < number; i++) {
      items.push(i);
    }
    return items;
  }

  goBack() {
    if (this.searchObjectService.isValidSearchObject()) {
      this.searchObjectService.setSearchURL(true, this.searchObjectService.getLoginType());
    } else {
      this.router.navigate(['find']);
    }
  }

  clickDistance(event) {
    // sheet function
    this.sheetsService.changeSheets(this.detailData);
    event.stopPropagation();
  }

  openHoverSheet(event, title, message) {
    // sheet function
    this.sheetsService.changeSheets({
      isMessage: true,
      title: title,
      message: message
    });
    event.stopPropagation();
  }

  print() {
    const services = this.showServices;
    const otherDoctors = this.showOtherDoctors;
    const showPlans = this.showPlans;
    const showLanguages = this.showLanguages;
    const showDetailData = this.showDetailData;
    if (this.detailData && this.detailData.services && this.detailData.services.length !== 0) {
      this.showServices = this.detailData.services.length;
    }
    if (this.otherDoctorData && this.otherDoctorData.practitioners && this.otherDoctorData.practitioners.length !== 0) {
      this.showOtherDoctors = this.otherDoctorData.practitioners.length;
    }
    if (this.detailData && this.detailData.locations && this.detailData.locations.length !== 0 && this.detailData.locations[0].plansAccepted) {
      if (this.detailData.locations[0].plansAccepted) {
        this.showPlans = this.detailData.locations[0].plansAccepted.length;
      }

      if (this.detailData.locations[0].officeLanguages) {
        this.showLanguages = this.detailData.locations[0].officeLanguages.length;
      }
    }
    if (this.showLocationData && this.showLocationData.length !== 0) {
      this.showDetailData = this.showLocationData.length;
      }
    this.setMap = !this.setMap;

    const _self = this;
    setTimeout(function () {
      window.print();
      _self.showServices = services;
      _self.showOtherDoctors = otherDoctors;
      _self.showPlans = showPlans;
      _self.showLanguages = showLanguages;
      _self.showDetailData = showDetailData;
      _self.setMap = !_self.setMap;
    }, 1000);

  }

  onMarkerClickEvent(letter) {
    this.activeMarkerLetter = letter;
  }

}
